module.exports = __webpack_public_path__ + "img/banner-cat.7f10cb4c.png";